import React from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import ProductImage from '../../common/ProductImage';
import EditButton from '../../common/EditButton';
import ViewButton from '../../common/ViewButton';
import DeleteButton from '../../common/DeleteButton';
import { Form } from 'react-bootstrap';

const PackageBox = ({
      loading,
      packages,
      loadData,
      setPackages,
      setLoading
}) => {
      const token = JSON.parse(localStorage.getItem('token'));

      const handleStatus = async (item) => {
            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/packages/${item.slug}/status`,
                        {},
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              toast.error(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleDelete = async (item) => {
            const response = await axios
                  .delete(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/packages/${item.slug}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setPackages((packages) =>
                                    packages.filter(
                                          (item) => item.id !== item.id
                                    )
                              );
                              loadData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <thead>
                        <tr>
                              <th>#</th>
                              <th>Title</th>
                              <th>Destination</th>
                              <th>Duration</th>
                              <th>Price</th>
                              <th width="80px">Status</th>
                              <th width="120px">Action</th>
                        </tr>
                  </thead>

                  <tbody>
                        {!loading ? (
                              packages?.length > 0 ? (
                                    packages?.map((item, index) => (
                                          <>
                                                <tr key={index}>
                                                      <td>
                                                            {item.index
                                                                  ? item.index
                                                                  : ++index}
                                                      </td>
                                                      <td>
                                                            <ProductImage
                                                                  title={
                                                                        item.title
                                                                  }
                                                                  image={
                                                                        item.image
                                                                  }
                                                                  category={`Type: ${item.package_type}`}
                                                            />
                                                      </td>
                                                      <td>
                                                            <ProductImage
                                                                  title={
                                                                        item.destination
                                                                  }
                                                                  category={`Category: ${item.hotel_category}`}
                                                            />
                                                      </td>
                                                      <td>
                                                            <ProductImage
                                                                  title={
                                                                        item.duration
                                                                  }
                                                                  category={`Size: ${item.group_size}`}
                                                            />
                                                      </td>
                                                      <td>
                                                            <ProductImage
                                                                  title={
                                                                        item.price
                                                                  }
                                                                  category={`${item.price_type}`}
                                                            />
                                                      </td>
                                                      <td className="text-center">
                                                            <Form.Check
                                                                  type="switch"
                                                                  defaultChecked={
                                                                        item.status ===
                                                                        1
                                                                              ? true
                                                                              : false
                                                                  }
                                                                  onClick={() =>
                                                                        handleStatus(
                                                                              item
                                                                        )
                                                                  }
                                                            />
                                                      </td>
                                                      <td className="text-center">
                                                            <EditButton
                                                                  link={`/dashboard/packages/${item.slug}/edit`}
                                                            />
                                                            <ViewButton
                                                                  link={`/dashboard/packages/${item.slug}/show`}
                                                            />
                                                            <DeleteButton
                                                                  item={item}
                                                                  loading={
                                                                        loading
                                                                  }
                                                                  setLoading={
                                                                        setLoading
                                                                  }
                                                                  handleDelete={
                                                                        handleDelete
                                                                  }
                                                            />
                                                      </td>
                                                </tr>
                                          </>
                                    ))
                              ) : (
                                    <>
                                          <tr>
                                                <td
                                                      colSpan={8}
                                                      className="text-center"
                                                >
                                                      No Product Found
                                                </td>
                                          </tr>
                                    </>
                              )
                        ) : (
                              <>
                                    <tr>
                                          <td
                                                colSpan={8}
                                                className="text-center"
                                          >
                                                Loading...
                                          </td>
                                    </tr>
                              </>
                        )}
                  </tbody>
            </>
      );
};

export default PackageBox;
